import { createSlice } from '@reduxjs/toolkit';

export interface ReceiveRemindersModalSliceState {
  isOpen: boolean;
}

const initialState: ReceiveRemindersModalSliceState = {
  isOpen: false,
};

const receiveRemindersModalSlice = createSlice({
  name: 'receiveRemindersModal',
  initialState,
  reducers: {
    openModal: (state) => {
      console.log('Open');
      state.isOpen = true;
    },
    closeModal: (state) => {
      console.log('Close');
      state.isOpen = false;
    },
  },
});

export { receiveRemindersModalSlice };
